import { styled } from 'styled-components';
import { ResponsiveImageSkeleton } from '../Image/styles';
export const Wrapper = styled.div `
  position: relative;
  text-align: center;

  ${ResponsiveImageSkeleton} {
    border-radius: 5px;
  }
`;
export const VideoOverlay = styled.div `
  border-radius: 50%;
  width: 44px;
  height: 44px;
  background-color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
`;
export const VideoPlayIcon = styled.span `
  position: absolute;
  top: 15px;
  left: 17px;
`;
//# sourceMappingURL=styles.js.map